import 'intl';
import 'intl/locale-data/jsonp/ar';
import 'intl/locale-data/jsonp/de';
import 'intl/locale-data/jsonp/en';
import 'intl/locale-data/jsonp/es';
import 'intl/locale-data/jsonp/fr';
import 'intl/locale-data/jsonp/it';
import 'intl/locale-data/jsonp/ja';
import 'intl/locale-data/jsonp/nl';
import 'intl/locale-data/jsonp/pt';
import 'intl/locale-data/jsonp/ru';
import 'intl/locale-data/jsonp/zh';
import './locale/co';

import getLocale from './getLocale';

function getNbDecimal(v) {
    //console.log('getNbDecimal');
    let dec = 0;

    if (v) {
        const tmp = v.split('.');
        if (typeof tmp === 'object' && typeof tmp[1] === 'string') {
            //console.log(tmp[1]);
            //console.log(tmp[1].charAt(tmp[1].length-1));
            if (tmp[1].charAt(tmp[1].length - 1) === '0') {
                return tmp[1].length - 1;
            }
            //console.log(tmp[1].length);

            return tmp[1].length;
        }
    }

    return dec;
}

const intlPrice = (business, price, lang, currency = false) => {
    //const locale = getLocale(lang, currency);

    //price = 8.05;

    let force_decimal = 1;

    if (
        typeof business !== 'undefined' &&
        business.info &&
        typeof business.info.force_decimal === 'number'
    ) {
        force_decimal = business.info.force_decimal;
    }

    if (business.info.currency === 'COP') {
        lang = 'es-co';
    }

    //console.log('DEBUG');
    //console.log(currency);
    //console.log(force_decimal);
    //console.log(business.info.force_decimal);

    if (currency && typeof currency === 'string' && lang) {
        //console.log('DEBUG');
        //console.log(price);

        if (force_decimal === 0) {
            try {
                return new Intl.NumberFormat(lang, {
                    minimumFractionDigits: getNbDecimal(price),
                    maximumFractionDigits: getNbDecimal(price),
                    style: 'currency',
                    currency: currency,
                }).format(price);
            } catch (err) {
                return '';
            }
        }

        try {
            return new Intl.NumberFormat(lang, {
                style: 'currency',
                currency: currency,
            }).format(price);
        } catch (err) {
            return '';
        }
    }

    if (price) {
        if (price === '0') {
            price = 0;
        }

        try {
            return new Intl.NumberFormat(lang, {
                style: 'currency',
                currency: currency,
            }).format(price);
        } catch (err) {
            return '';
        }
    }

    return '';
};

export default intlPrice;
